(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && nav) {
    var setMenuOpen = function (open) {
      menuToggle.setAttribute('aria-expanded', String(open));
      nav.hidden = !open;
      document.body.classList.toggle('menu-open', open);
    };

    menuToggle.addEventListener('click', function () {
      setMenuOpen(menuToggle.getAttribute('aria-expanded') !== 'true');
    });

    // Close when a link is tapped, on Escape, on a tap outside the header, or when resizing to desktop.
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMenuOpen(false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !nav.hidden) {
        setMenuOpen(false);
        menuToggle.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!nav.hidden && !nav.contains(event.target) && !menuToggle.contains(event.target)) setMenuOpen(false);
    });
    window.matchMedia('(min-width: 641px)').addEventListener('change', function (mq) {
      if (mq.matches) setMenuOpen(false);
    });
  }

  document.querySelectorAll('[data-sticky-submit]').forEach(function (button) {
    button.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (!form) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  });

  var contactSuccess = document.querySelector('[data-contact-success]');
  if (contactSuccess && window.location.search.indexOf('contact_posted=true') !== -1) {
    contactSuccess.hidden = false;
  }
})();
